// ======================================================================
// File Name       : RegistrationContentListSelection
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Form, FormControl, Col, Button, Modal, Table } from 'react-bootstrap';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE, RETURN_MAX_NUM } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import PaginationCustom from '../Pagination';
import TableHead, { setSortState } from '../TableHead';
import { getItemBoxName } from '../../utils/index';
import { CONTENT_DISTRIBUTION_CONTENT_TYPE } from '../../constants/ContentDistributionConstant';
import * as DistributionAction from '../../actions/ContentDistributionAction';
import MessageSearch from '../../components/MessageSearch';
import CustomButton from '../button/CustomButton';

class RegistrationContentListSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentId: '',
      contentName: '',
      contentType: '',
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      ascendingDescendingSort: 0,
      contentSortType: null,

      contentList: [],
      recordNum: 0,
      isAllowShowSearchMessage: false,
      isInit: true,
      selectedList: [],
    };
    this.validation = this.validation.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.searchContent = this.searchContent.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleIsChecked = this.handleIsChecked.bind(this);
  }

  /**
   * componentDidMount event executed after first render
   */
  componentDidMount() {
    this.searchContent();
  }

  componentWillReceiveProps(nextProps) {
    const { contentDistribution } = nextProps;
    if (!contentDistribution || !contentDistribution.distributionOfferList) {
      return;
    }
    const { distributionOfferList } = contentDistribution;
    const {
      contentSearchResult,
      distributionContentList,
     } = distributionOfferList;
    if (contentSearchResult) {
      const { contentList, recordNum } = contentSearchResult;
      this.setState({ contentList, recordNum });
    }
  }

  searchContent() {
    if (!this.validation()) {
      return;
    }
    const {
      contentId,
      contentType,
      contentName,
      contentSortType,
      ascendingDescendingSort,
      startPosition,
      returnMaxNum } = this.state;
    const params = {
      searchInfo: {
        contentSecernId: contentId || null,
        contentType: contentType || null,
        contentName: contentName || null,
        contentSortType,
        ascendingDescendingSort,
        startPosition,
        returnMaxNum,
        excludeQuestion: true,
      },
    };
    this.props.dispatch(
      DistributionAction.getContentDistributionContentList(params),
    ).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  handleSearch() {
    const isValid = this.validation();
    if (isValid) {
      this.setState({
        startPosition: 0,
        isAllowShowSearchMessage: false,
        isInit: false,
      }, () => {
        this.searchContent();
      });
    }
  }

  getStartEndData(startPosition) {
    const isValid = this.validation();
    if (isValid) {
      this.setState({
        startPosition,
        isInit: false,
      }, () => {
        this.searchContent();
      });
    }
  }

  handleSortState(row) {
    const isValid = this.validation();
    if (isValid) {
      this.setState({
        ascendingDescendingSort: row.sortState,
        contentSortType: row.sortBy,
        isInit: false,
      }, () => {
        this.searchContent();
      });
    }
  }

  handleCheckbox(id, contentType, event) {
    const { contentList, selectedList } = this.state;
    for (const content of contentList) {
      if (content.contentSecernId && content.contentSecernId === id && content.contentType === contentType) {
        content.isChecked = content.isChecked ? !content.isChecked : true;
        if (content.isChecked) {
          selectedList.unshift(content);
        } else {
          for (let i = 0; i < selectedList.length; i++) {
            if (selectedList[i].contentSecernId === id && selectedList[i].contentType === contentType) {
              selectedList.splice(i, 1);
            }
          }
        }
      }
    }
    this.setState({ contentList });
  }

  handleCheckAll() {
    const { contentList, selectedList } = this.state;
    let selectedCheck = [];
    const checkQuestionIdChecked = [];
    if (selectedList && selectedList.length) {
      selectedCheck = selectedList.reduce((acc, cur) => {
        if (cur.contentSecernId && !isNaN(parseInt(cur.contentType, 10))) {
          acc.push(`${cur.contentSecernId}.${cur.contentType}`);
        }
        return acc;
      }, []);
    }
    if (contentList && contentList.length) {
      contentList.map((content) => {
        const pos = selectedCheck.indexOf(`${content.contentSecernId}.${content.contentType}`);
        if (pos > -1) {
          checkQuestionIdChecked.push(pos);
        }
      });
      if (checkQuestionIdChecked.length === contentList.length) {
        // uncheckAll
        contentList.map((content) => {
          const pos = selectedCheck.indexOf(`${content.contentSecernId}.${content.contentType}`);
          if (pos > -1) {
            content.isChecked = false;
            selectedCheck.splice(pos, 1);
            selectedList.splice(pos, 1);
          }
          return null;
        });
        this.setState({
          contentList,
          selectedList,
        });
        return;
      }
      contentList.map((content) => {
        if (selectedCheck.indexOf(`${content.contentSecernId}.${content.contentType}`) < 0) {
          content.isChecked = true;
          selectedList.unshift(content);
        }
        return null;
      });
      this.setState({
        contentList,
        selectedList,
      });
    }
  }

  /**
   * Handle event when click on OK of  dialog
   */
  onOk() {
    let contentList = [];
    let contentCheck = [];
    if (this.props.contentDistribution && this.props.contentDistribution.distributionOfferList
      && this.props.contentDistribution.distributionOfferList.distributionContentList
      && this.props.contentDistribution.distributionOfferList.distributionContentList.length) {
      contentList = this.props.contentDistribution.distributionOfferList.distributionContentList;
      contentCheck = contentList.reduce((acc, cur) => {
        if (cur.contentSecernId && !isNaN(parseInt(cur.contentType, 10))) {
          acc.push(`${cur.contentSecernId}.${cur.contentType}`);
        }
        return acc;
      }, []);
    }
    if (this.state.selectedList && this.state.selectedList.length) {
      this.state.selectedList.map((selectedItem) => {
        const pos = contentCheck.indexOf(`${selectedItem.contentSecernId}.${selectedItem.contentType}`);
        if (pos < 0) {
          contentList.push(selectedItem);
        }
      });
    }
    this.props.onDialogOK(contentList);
  }

  /**
   * Handle event when click on cancel of  dialog
   */
  onCancel() {
    this.setState({ selectedList: [] });
    this.props.onDialogCancel();
  }

  handleIsChecked(contentList, selectedContentList, isDisabled) {
    if (
      contentList &&
      contentList.length &&
      selectedContentList &&
      selectedContentList.length
    ) {
      const selectedList = selectedContentList.reduce((acc, cur) => {
        if (cur.contentSecernId && !isNaN(parseInt(cur.contentType, 10))) {
          acc.push(`${cur.contentSecernId}.${cur.contentType}`);
        }
        return acc;
      }, []);
      for (let i = 0; i < contentList.length; i++) {
        const index = selectedList.indexOf(`${contentList[i].contentSecernId}.${contentList[i].contentType}`);
        if (index > -1) {
          if (!contentList[i].isChecked) {
            contentList[i].isChecked = true;
            contentList[i].isDisabled = isDisabled;
          }
        }
      }
    }
    return contentList;
  }
  /**
 * Handle change input field
 *
 * @param {*} event
 */
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const thead = [
      { title: '', sortBy: null, width: 50 },
      { title: 'コンテンツ識別ID', sortBy: 0 },
      { title: 'コンテンツ名', sortBy: 2 },
      { title: 'コンテンツ種別', sortBy: 1 },
    ];
    this.refsToValidate = [];
    let contentSearchResultTableData = null;
    const {
      showModal,
    } = this.props;
    const {
      contentId,
      contentName,
      contentType,
      startPosition,
      returnMaxNum,
      ascendingDescendingSort,
      contentSortType,
      contentList,
      recordNum,
      selectedList,
    } = this.state;
    let isExistContentChecked = [];
    if (this.props.contentDistribution && this.props.contentDistribution.distributionOfferList
      && this.props.contentDistribution.distributionOfferList.distributionContentList
      && this.props.contentDistribution.distributionOfferList.distributionContentList.length) {
      isExistContentChecked = this.props.contentDistribution.distributionOfferList.distributionContentList;
    }
    let list = [];
    list = this.handleIsChecked(
      contentList,
      isExistContentChecked,
      true,
    );
    // set is checked for selected content temporary
    list = this.handleIsChecked(
      contentList,
      selectedList,
      false,
    );
    if (list && list.length) {
      contentSearchResultTableData = list.map(
      (content, index) => (
        <tr key={index}>
          <td>
            <Form.Check
              type='checkbox'
              className="padding-clear margin-top-4"
              checked={
                  content.isChecked ? content.isChecked : false
                }
              onChange={this.handleCheckbox.bind(
                  this,
                  content.contentSecernId,
                  content.contentType,
                )}
              disabled={content.isDisabled || false} />
          </td>
          <td>
            {content.contentSecernId}
          </td>
          <td>
            {content.contentName}
          </td>
          <td>
            {getItemBoxName(
                CONTENT_DISTRIBUTION_CONTENT_TYPE,
                content.contentType,
              )}
          </td>
        </tr>
        ),
      );
    }
    let data = thead;
    if (this.state) {
      const sortBy = this.state.contentSortType;
      const sortState = this.state.ascendingDescendingSort;
      data = setSortState(thead, sortBy, sortState);
    }
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={'lg'}
        style={style}
        dialogClassName="content-distribution-offer-list-dialog"
      >
        <Modal.Header onHide={this.onCancel} closeButton>
          <Modal.Title className="text-center">
            配布するコンテンツを選択してください
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <MessageSearch
              recordNum={recordNum}
              resultList={contentList}
              isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
              dismissMessage={this.dismissMessage}
            />
            <Form onSubmit={(e) => { e.preventDefault(); this.handleSearch(); }} className='form-horizontal'>
              <Form.Group
                className="form-info padding-left-35"
                controlId="formHorizontalDialogContentId"
              >
                <Col as={Form.Label} sm={4}>
                  コンテンツ識別ID
                </Col>
                <Col sm={6}>
                  <FormControlValidate
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    type="text"
                    name="contentId"
                    value={contentId}
                    maxLength="64"
                    label="コンテンツ識別ID"
                    validateType={VALIDATE_TYPE.ID}
                    onChange={this.handleChange}
                    messageError={MessageTemplate.MSG_ID_INVALID}
                    messageSuccess={MessageTemplate.MSG_ID_VALID}
                  />
                </Col>
              </Form.Group>
              <Form.Group
                className="form-info padding-left-35"
                controlId="formHorizontalDialogContentName"
              >
                <Col as={Form.Label} sm={4}>
                  コンテンツ名
                </Col>
                <Col sm={6}>
                  <FormControl
                    type="text"
                    maxLength="256"
                    name="contentName"
                    value={contentName || ''}
                    onChange={this.handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group
                className="form-info padding-left-35"
                controlId="formHorizontalDialogContentType"
              >
                <Col as={Form.Label} sm={4}>
                  コンテンツ種別
                </Col>
                <Col sm={6}>
                  <Form.Select
                    name="contentType"
                    value={contentType || null}
                    onChange={this.handleChange}
                  >
                    <option value={null} />
                    <option value={0}>ビデオ</option>
                    <option value={1}>ドリル</option>
                    <option value={3}>ドキュメント</option>
                    <option value={5}>リンク</option>
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col className="text-center">
                  <CustomButton
                    btnStyle="btn btn-primary btn-96"
                    type="submit"
                    text="検索"
                    iconClass="bi bi-search"
                  />
                </Col>
              </Form.Group>
              <Col sm={2} >
                <Button variant="default" onClick={this.handleCheckAll}>
                  全選択/解除
                </Button>
              </Col>
              <Col sm={10}>
                <PaginationCustom
                  className="float-end"
                  recordNum={recordNum}
                  handlePageSelect={this.getStartEndData}
                  startPosition={startPosition}
                />
              </Col>
              <Col>
                <Table striped hover className="margin-top-10">
                  <thead>
                    <TableHead data={thead} handleSortState={this.handleSortState} />
                  </thead>
                  <tbody>
                    {contentSearchResultTableData}
                  </tbody>
                </Table>
              </Col>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer className="text-center">
          <Button
            variant="default"
            className=" margin-right-10 btn-96"
            onClick={this.onCancel}
          >
            キャンセル
          </Button>
          <Button
            className=" margin-left-10 btn-96"
            variant="primary"
            onClick={this.onOk}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ contentDistribution: state.contentDistribution },
});

export default connect(mapStateToProps)(RegistrationContentListSelection);
